import PageHeader from "../components/PageHeader";
import HireIOSDeveloperContent from "../components/HireIOSDevelopers-Content";

const HireAndroidDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="IOS Developer" breadcrumbMenu="Home" breadcrumbMenuActive="IOS Developer" image="/images/ios-developer-banner.jpg" />
            <HireIOSDeveloperContent />
        </>
    )
}

export default HireAndroidDevelopers;